import React from "react";
import { Box, Heading, Image, Paragraph, ResponsiveContext, Text } from "grommet";
export var AthleteCard = function AthleteCard(_ref) {
  var photo = _ref.photo,
    name = _ref.name,
    surname = _ref.surname,
    birthDate = _ref.birthDate,
    grade = _ref.grade,
    paragraph = _ref.paragraph;
  return /*#__PURE__*/ React.createElement(
    "div",
    null,
    /*#__PURE__*/ React.createElement(ResponsiveContext.Consumer, null, function (size) {
      return /*#__PURE__*/ React.createElement(
        Box,
        {
          flex: true,
          direction: "row",
          background: {
            color: "site-colors-1",
          },
          round: "20px",
          gap: "medium",
        },
        /*#__PURE__*/ React.createElement(
          Box,
          {
            width: {
              max: "140px",
            },
            height: "152",
          },
          /*#__PURE__*/ React.createElement(Image, {
            fit: "cover",
            src: photo,
            style: {
              borderRadius: "20px 0 0 20px",
            },
          })
        ),
        /*#__PURE__*/ React.createElement(
          Box,
          {
            color: "light",
            pad: {
              vertical: "medium",
            },
            gap: "xsmall",
          },
          /*#__PURE__*/ React.createElement(
            Heading,
            {
              level: 4,
            },
            "Athlete ",
            name,
            " ",
            surname,
            " |",
            " ",
            /*#__PURE__*/ React.createElement(
              Text,
              {
                size: "18px",
                weight: "normal",
              },
              "Birth"
            ),
            " ",
            birthDate
          ),
          /*#__PURE__*/ React.createElement(
            Box,
            {
              gap: "small",
            },
            /*#__PURE__*/ React.createElement(
              Paragraph,
              {
                size: "0.625rem",
                style: {
                  opacity: "0.6",
                },
              },
              grade
            ),
            /*#__PURE__*/ React.createElement(
              Paragraph,
              {
                size: "medium",
                style: {
                  textTransform: "uppercase",
                },
              },
              paragraph
            )
          )
        )
      );
    })
  );
};
